/**
 * Get user display name from multiple fields
 */
export const getUserDisplayName = ({ name, username, primaryEmail, primaryPhone, }) => {
    return name ?? username ?? primaryEmail ?? primaryPhone ?? 'Unnamed User';
};
